import { create } from 'zustand';
import { WorkspaceMassActionsConfig } from '../../components/v2/layout/MassActionsBar/massActionsBar.types';

interface WorkspaceMassActionsStore {
  config: WorkspaceMassActionsConfig<unknown>;
  setConfig: (config: WorkspaceMassActionsConfig<unknown>) => void;
}

const useWorkspaceMassActionsStore = create<WorkspaceMassActionsStore>((set) => ({
  config: null,
  setConfig: (config) => set({ config }),
}));

export default useWorkspaceMassActionsStore;
